var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profile)?_c('p',{domProps:{"innerHTML":_vm._s(
      _vm.$t('message', { fullname: _vm.profile.fullname, email: _vm.profile.email })
    )}}):_vm._e(),_c('hr'),_c('b-form',[_c('InputGroup',{attrs:{"v":_vm.v$.email,"placeholder":_vm.$tc('placeholder'),"label":_vm.$tc('email'),"autoFocus":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }